import * as Yup from 'yup';
//import {t} from 'i18next';
export const digitsOnly = Yup.string().test(
	'is-number',
	'Мають бути цифри',
	(value) => {
		if (!value) return true;
		return !isNaN(Number(value));
	},
);
export const validationFilterForm = Yup.object().shape({
	order_id: digitsOnly,
	product_id: digitsOnly,
	sum_cash: digitsOnly,
	amount: digitsOnly,
});
export const validateCreateDeferred = (balance: number) =>
	Yup.object().shape({
		orders: Yup.array()
			.of(
				Yup.object().shape({
					points: Yup.number()
						.typeError('Бали повинні бути числом')
						.required('Бали обов\'язкові')
						.max(balance, `Бали не можуть перевищувати ${balance}`),
					user_id: Yup.string()
						.min(6, 'Помилка Юзера')
						.required('ID користувача обов\'язковий'),
				}),
			)
			.test(
				'total-balance',
				`Загальна кількість балів не може перевищувати ${balance}`,
				function (orders) {
					if (!orders) return true;
					const total = orders.reduce((acc, el) => {
						const points = parseFloat(el.points as any);
						return acc + (isNaN(points) ? 0 : points);
					}, 0);

					if (total > balance) {
						// Ошибка привязывается к первому элементу массива
						return this.createError({
							path: 'orders[0].points',
							message: `Загальна кількість балів (${total}) перевищує баланс (${balance})`,
						});
					}
					return true;
				},
			),
	});

// Схема валидации для формы CreateInvoice
export const validateCreateInvoice = Yup.object().shape({
	// Обязательные поля из CreateInvoiceType
	type: Yup.string()
		.required("Тип накладної обов'язковий")
		.oneOf(
			['income', 'outcome', 'pre-order', 'write-off', 'order'],
			'Невірний тип накладної',
		),
	ware_id: Yup.string().required("Склад обов'язковий"),

	contact_id: Yup.string().test(
		'contact-required',
		"Контакт обов'язковий",
		function (value) {
			// Проверяем, есть ли выбранный контакт или создается новый
			const newContactPhone = this.parent.newContactPhone;
			if (!value && !newContactPhone) {
				return false;
			}
			return true;
		},
	),
	address_id: Yup.string().test(
		'address-required',
		"Адреса обов'язкова",
		function (value) {
			// Проверяем, есть ли выбранная адреса или создается новая
			const serviceType = this.parent.service_type;
			if (!value && serviceType) {
				return false;
			}
			return true;
		},
	),
	// Опциональные поля
	comment: Yup.string().max(500, 'Коментар не може перевищувати 500 символів'),
	order_id: Yup.string(),
	// Поля для доставки (обязательные при выборе доставки)
	service_type: Yup.string().when('type', {
		is: (type: string) => type === 'income' || type === 'outcome',
		then: (schema) => schema.required("Тип доставки обов'язковий"),
		otherwise: (schema) => schema,
	}),
});
